<script lang="ts">
	import ResultMessageIcon from '$assets/pois/no-poi.webp';
	import * as m from '$paraglide/messages';

	interface Props {
		isOpen: boolean;
		message: string;
	}

	const { isOpen, message }: Props = $props();
</script>

<li class="relative element-disabled flex flex-shrink-0 whitespace-nowrap gap-x-2 items-center px-4 py-2 bg-neutral-soft text-sm rd-1" aria-hidden={!isOpen}>
	<img
		width="16px"
		height="16px"
		src={ResultMessageIcon}
		alt={m.search_tools__messages__image_alt()}
	/>
	<span>
		{message}
	</span>
</li>
